let agent = null

export async function create (request) {
  if (IS_BROWSER) {
    return window.fetch.bind(window)
  }

  if (!request) {
    throw new Error('fetch: a valid request is required')
  }

  if (!agent) {
    const https = await import('https')
    const isDev = process.argv.includes('-dev') || process.argv.includes('--dev')
    const rejectUnauthorized = !isDev && IS_PRODUCTION

    agent = new https.Agent({
      keepAlive: true,
      keepAliveMsecs: 1000 * 60 * 5,
      rejectUnauthorized,
    })
  }

  const { default: nodeFetch } = await import('node-fetch')

  const fetch = function (url, options = {}) {
    options.headers = {
      cookie: request.headers.cookie,
      connection: 'keep-alive',
      ...(options.headers || {}),
    }

    if (!options.headers.cookie) {
      delete options.headers.cookie
    }

    if (typeof fetch.auth === 'string' && fetch.auth) {
      options.headers.authorization = fetch.auth
    }

    return nodeFetch(url, {
      ...options,
      agent,
    })
  }

  return fetch
}
